import { render, staticRenderFns } from "./UserPurchaseHistory.vue?vue&type=template&id=20ddc68b"
import script from "./UserPurchaseHistory.vue?vue&type=script&lang=js"
export * from "./UserPurchaseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports